import React from 'react';
import { format, addMonths } from 'date-fns';
import { Repeat } from 'lucide-react';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Switch } from './ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// Same repeat choices and behavior as the main Appointments tab (shown for types with the SNAP E&T reminder trigger)
export const CaseAppointmentRecurring = ({ value, onChange }) => (
  <div className="space-y-4 p-4 border border-purple-200 rounded-lg bg-purple-50/50" data-testid="case-appointment-recurring">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Repeat className="w-4 h-4 text-purple-600" />
        <Label className="font-medium">Make this a recurring appointment</Label>
      </div>
      <Switch
        checked={value.is_recurring}
        onCheckedChange={(checked) => onChange({ is_recurring: checked, recurrence_end_date: checked ? format(addMonths(new Date(), 3), 'yyyy-MM-dd') : '' })}
        data-testid="case-recurring-toggle"
      />
    </div>
    {value.is_recurring && (
      <div className="space-y-4 pt-2">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Repeat Every</Label>
            <div className="flex gap-2">
              <Input type="number" min="1" max="30" value={value.recurrence_interval} className="w-20"
                onChange={(e) => onChange({ recurrence_interval: parseInt(e.target.value) || 1 })} data-testid="case-recurrence-interval" />
              <Select value={value.recurrence_unit} onValueChange={(v) => onChange({ recurrence_unit: v })}>
                <SelectTrigger className="flex-1" data-testid="case-recurrence-unit"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="days">Days</SelectItem>
                  <SelectItem value="weeks">Weeks</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-2">
            <Label>End Date</Label>
            <Input type="date" value={value.recurrence_end_date} min={value.date}
              onChange={(e) => onChange({ recurrence_end_date: e.target.value })} data-testid="case-recurrence-end-date" />
          </div>
        </div>
        <p className="text-xs text-muted-foreground">Each occurrence will receive a separate 24-hour SMS reminder (if SNAP E&T).</p>
      </div>
    )}
  </div>
);

export const AppointmentCaseManagerSelect = ({ value, staffList, onChange, disabled, testId }) => (
  <Select value={value || 'none'} onValueChange={(v) => onChange(v === 'none' ? null : v)} disabled={disabled}>
    <SelectTrigger className="h-8 w-52 text-xs" data-testid={testId}><SelectValue placeholder="Case manager" /></SelectTrigger>
    <SelectContent>
      <SelectItem value="none">No case manager</SelectItem>
      {staffList.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
    </SelectContent>
  </Select>
);
